<template>
    <i-alert class="uploadinfo" variant="info" size="sm" v-if="!hideUploadInfo">
        <template slot="icon"><i-icon icon="info" size="lg" /></template>
        <div>
            {{ $t('uploadinfo') }}
        </div>
    </i-alert>
</template>

<style lang="scss">
@import '~@inkline/inkline/src/css/config';
@import '~@inkline/inkline/src/css/mixins';

.uploadinfo {
    font-size: font-sizes('sm');
    margin: 0 $spacer $spacer;
}

.area:not(.-box) {
    .uploadinfo {
        margin: 0 0 $spacer;
    }
}
</style>

<script>
import {
    IAlert,
    IIcon
} from '@inkline/inkline/src/components';

export default {
    name: 'UploadInfo',
    components: {
        IAlert,
        IIcon
    },
    computed: {
        hideUploadInfo() {
            return this.$route.query.hideUploadInfo;
        }
    }
};
</script>
